import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import store  from "./redux/redux-store";
import {Provider} from "react-redux";

let renderEntireTree = (store) => {
    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <App store={store}/>
            </Provider>
        </React.StrictMode>,
        document.getElementById('root')
    );

}
// eslint-disable-next-line no-undef
renderEntireTree(store)

window.store = store

export default renderEntireTree;

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
